import type { IconName } from "@local-logic/core/icons";
import type { POICategory, POIGroup, SchoolGroup } from "./types";

export const categories: {
  [key in POICategory]: {
    icon: IconName;
    pois: POIGroup | SchoolGroup;
  };
} = {
  schools: {
    icon: "Books",
    pois: ["primary_schools", "high_schools"],
  },
  restaurants: {
    icon: "SpoonAndFork",
    pois: ["restaurants", "healthy_restaurants"],
  },
  groceries: {
    icon: "Storefront",
    pois: ["groceries", "groceries_specialized"],
  },
  shopping: {
    icon: "CartPlusInside",
    pois: ["shopping"],
  },
  nightlife: {
    icon: "Brandy",
    pois: ["nightlife"],
  },
  cafes: {
    icon: "Coffee",
    pois: ["cafes"],
  },
  daycares: {
    icon: "Baby",
    pois: ["daycares"],
  },
  busStops: {
    icon: "Bus",
    pois: ["bus_stops"],
  },
  metroStations: {
    icon: "Train",
    pois: ["rapid_transit_stations"],
  },
  trainStations: {
    icon: "TrafficSignal",
    pois: ["train_stations"],
  },
  parks: {
    icon: "Tree",
    pois: ["parks"],
  },
  fitness: {
    icon: "Barbell",
    pois: ["fitness", "sport_facilities"],
  },
  medical: {
    icon: "Heartbeat",
    pois: ["health_care"],
  },
  petCare: {
    icon: "PawPrint",
    pois: ["pet_care"],
  },
  fuelStations: {
    icon: "GasPump",
    pois: ["car_fueling_stations"],
  },
  activities: {
    icon: "Palette",
    pois: ["art_culture_science"],
  },
  homeImprovement: {
    icon: "Armchair",
    pois: ["home_improvement"],
  },
  personalCare: {
    icon: "Brain",
    pois: ["personal_care"],
  },
};

// km and mi
export const radiusOptions = {
  metric: [3, 6, 9],
  imperial: [2, 4, 6],
};
